<template>
  <SimpleDataCard
      :title="'Toplam ERP Sipariş Sayısı'"
      :data="reportCompanyData.totalErpOrder.toString()"
      :description="'Tüm Zamanlar'"
      :loading="reportCompanyDataLoading"
  >

  </SimpleDataCard>
</template>

<script>

import SimpleDataCard from "@/components/dashboard/SimpleDataCard";
import {numberConverter} from "../../../../helpers";
import {mapState} from "vuex";

export default {
  name: "ToplamERPSiparisSayisi",
  components:{
    SimpleDataCard
  },
  computed: {
    ...mapState("dashboard",["reportCompanyData","reportCompanyDataLoading"])
  },
  methods:{
    numberConverter
  }
}
</script>

<style scoped>

</style>